import { render } from "./DashboardRouter.vue?vue&type=template&id=120262cc&ts=true"
import script from "./DashboardRouter.vue?vue&type=script&lang=ts"
export * from "./DashboardRouter.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__